import { useField } from "formik";

import RangeNodeType from "../../types/RangeNodeType";
import Slider from "@mui/material/Slider";

export const Range = ({ name, ...props }: RangeNodeType) => {
    const [field, , helpers] = useField(name);
    return (
        <Slider
            value={field.value || 0}
            onChange={(_, value) => helpers.setValue(value)}
            {...props}
        />
    );
};

export default Range;
